/* global window */
/* eslint import/prefer-default-export: 0 */
import { rekuest, method, headers, url, uri, body, debug } from 'rekuest'
import qs from 'qs'

const withEncodedBody = rek => ({
  ...rek,
  body: qs.stringify(rek.body),
})

export const saveSignature = async ({ name, city, email }) => {
  const apiUrl =
    window.location.href.indexOf('localhost') >= 0
      ? window.location.origin.replace('8301', '8302')
      : window.location.origin

  const request = await rekuest(
    method('POST'),
    url(apiUrl),
    uri('/api.php'),
    headers({
      'Content-Type': 'application/x-www-form-urlencoded',
    }),
    body({ name, city, email }),
    debug(true),
    withEncodedBody
  )

  const response = await request()
  const results = await response.json()

  return results
}
